/* ecnue bundles — セットの中身を選ぶUI
 *
 * 動き:
 *   1. App Proxy(/apps/bundle/definition) からセットの定義を取る
 *      → 登録が無ければ何も表示しない（通常商品・Simple Bundles のセットはここで抜ける）
 *   2. 枠ごとに「写真 + 名前 + プルダウン」を並べ、間を ＋ でつなぐ
 *   3. 親バリアント + 選択内容(_ecnue_selection) をカートに入れる
 *
 * ⚠️ Shopify Functions はこのストアでは使えない（実測: shopifyFunctions 0件・非Plus）。
 *    カートは展開されず、親1行 + properties のまま注文が立つ。
 *    中身を単品に分けて在庫を引くのは picking 側の仕事（lib/bundle-expand.ts）。
 * ⚠️ だから「選択内容が落ちたまま買われる」のをサーバーで止める手段が無い。
 *    全部選ぶまでボタンを押させないこと、テーマ標準のボタンを隠すことが唯一の防波堤。
 *    ここを緩めない。
 * ⚠️ 色のタイルを全部並べる作りは一度やめた（2026-10-23 翠さん「画像が出すぎ」）。
 *    37色ぶんの写真が縦に続いて、商品ページが写真だらけになっていた。
 *    枠ごとに写真は1枚だけ。選ぶとその商品の写真に変わる。
 */
(function () {
  var roots = document.querySelectorAll("[data-ecnue-bundle]");
  for (var i = 0; i < roots.length; i++) watch(roots[i]);

  /* バリアントの切り替えに追い続ける。
     ⚠️ バリアントごとに【中身の数も値段も違う】セットがある
        （base & top holiday kit の 2本 / 3本）。開いたときのバリアントしか
        見ていないと、3本に切り替えて3本選んでも2本の値段でカートに入る。
     ⚠️ 描き直す前に innerHTML を戻すこと。同じ枠に2回描くと
        カートに追加の口が二重になり、1回押して2つ入る。
     ⚠️ テーマの知らせ方は当てにしない（テーマごとに違う）。
        隠しフィールド [name=id] を本物として、変わっていたら描き直す。 */
  function watch(root) {
    var pristine = root.innerHTML;
    var wasHidden = root.hidden;
    var shown = null;
    function sync() {
      var v = currentVariant(root);
      if (!v || v === shown) return;
      shown = v;
      root.setAttribute("data-variant", v);
      restoreThemeButtons(root);
      root.innerHTML = pristine;
      root.hidden = wasHidden;
      setup(root);
    }
    sync();
    document.addEventListener("change", sync, true);
    document.addEventListener("variant:change", sync);
    // 上2つで拾えないテーマのための保険。値が同じなら何もしない
    setInterval(sync, 500);
  }

  /** いま売られているバリアント。隠しフィールド → URL → 置いてある値 の順 */
  function currentVariant(root) {
    var form = root.closest ? root.closest("form[action*='/cart/add']") : null;
    var input = form ? form.querySelector("[name='id']") : null;
    if (input && input.value) return String(input.value);
    try {
      var fromUrl = new URLSearchParams(window.location.search).get("variant");
      if (fromUrl) return String(fromUrl);
    } catch (e) { /* 古いブラウザ。置いてある値で続ける */ }
    return String(root.getAttribute("data-variant") || "");
  }

  /* 描き直す前に、前回隠したテーマのボタンを戻す。
     ⚠️ 戻さないと、セットの登録が無いバリアントへ切り替えたときに
        カートに追加の口が1つも無くなり、その商品が買えなくなる。 */
  function restoreThemeButtons(root) {
    var list = root.__ecnueHidden || [];
    for (var i = 0; i < list.length; i++) list[i].style.display = "";
    root.__ecnueHidden = [];
  }

  function setup(root) {
    var variantId = root.getAttribute("data-variant");
    var proxy = root.getAttribute("data-proxy") || "/apps/bundle";
    if (!variantId) return;

    fetch(proxy + "/definition?variant=" + encodeURIComponent(variantId), {
      headers: { Accept: "application/json" }
    })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        if (!data) return;
        // 発売前・終了後。中身は選べないので、親だけが買えないように止める
        if (!data.bundle && data.pending) { showPending(root, data.pending); return; }
        if (!data.bundle || !data.bundle.slots || !data.bundle.slots.length) return;
        render(root, data.bundle, variantId);
      })
      .catch(function () { /* 取得に失敗したら黙って通常表示のまま */ });
  }

  /* 期間外のとき。
     選択UIを出さずにテーマのカートボタンを止め、いつから売るかだけ伝える。
     ⚠️ ここを出さないと、中身を選ばないまま親だけがカートに入り、
        ピッキングで展開できない注文になる。 */
  function showPending(root, pending) {
    hideThemeButtons(root);
    var slotsEl = root.querySelector("[data-slots]");
    var addBtn = root.querySelector("[data-add]");
    var noteEl = root.querySelector("[data-note]");
    if (slotsEl) slotsEl.remove();
    if (addBtn) addBtn.remove();
    if (!noteEl) return;
    noteEl.textContent = pending.state === "after"
      ? "こちらのセットの販売は終了しました。"
      : whenText(pending.starts_at);
    noteEl.hidden = false;
    root.hidden = false;
  }

  function whenText(iso) {
    var d = iso ? new Date(iso) : null;
    if (!d || isNaN(d.getTime())) return "ただいま準備中です。";
    var hh = ("0" + d.getHours()).slice(-2);
    var mm = ("0" + d.getMinutes()).slice(-2);
    return (d.getMonth() + 1) + "月" + d.getDate() + "日 " + hh + ":" + mm + " から販売します。";
  }

  /* テーマ標準のカートボタンを止める。
     ⚠️ カートに入れる口は商品ページに1つとは限らない。
        このテーマは下に出るスティッキーバーにもう1つ持っていて、
        片方だけ隠すと、中身を選ばないまま親が買えてしまう。
     ⚠️ 「ページ中の /cart/add フォーム全部」では広すぎる。
        おすすめ商品のクイック追加まで消えるので、
        隠すのは親バリアントを売っているフォームだけにする。 */
  function hideThemeButtons(root) {
    var variantId = String(root.getAttribute("data-variant") || "");
    var forms = document.querySelectorAll("form[action*='/cart/add']");
    for (var i = 0; i < forms.length; i++) {
      var form = forms[i];
      var idInput = form.querySelector("[name='id']");
      var sells = idInput
        ? String(idInput.value) === variantId
        : form.contains(root);
      if (!sells) continue;
      var themeButtons = form.querySelectorAll(
        "[type=submit], .product-form__submit, .shopify-payment-button"
      );
      for (var b = 0; b < themeButtons.length; b++) {
        if (!root.contains(themeButtons[b])) {
          themeButtons[b].style.display = "none";
          // 切り替えで描き直すときに戻せるよう、隠したものを控えておく
          (root.__ecnueHidden = root.__ecnueHidden || []).push(themeButtons[b]);
        }
      }
    }
  }

  function render(root, bundle, variantId) {
    /* 最初から選ばれた状態にする色（data-preselect）。カンマ区切りで複数渡せる。
         商品ページ … その色を1つ（2026-10-23 翠さん）
         レシピ記事 … そのレシピで使っている色を全部（2026-10-25 翠さん）
       ⚠️ 同じ色を2つの枠に入れない。使った色はリストから取り除いていく。
       ⚠️ 在庫切れの色は入れない。選べないものが選ばれた状態になるとおかしい。 */
    var preQueue = (root.getAttribute("data-preselect") || "")
      .split(",").map(function (x) { return x.trim(); }).filter(Boolean);

    /* 固定モード（data-lock）。レシピ記事で使う。
       ⚠️ レシピ記事は「この配色のセット」なので、色を選ばせてはいけない
          （2026-10-25 翠さん「レシピのカラーしか選べないようにしたいから固定で」）。
          最初から入っている色はプルダウンを出さず、名前だけにする。
       ⚠️ 固定にするのは【先に入っている色だけ】。basic の base or top のように
          何も入っていない枠は、今までどおりお客様が選ぶ。 */
    var locked = root.getAttribute("data-lock") === "1";

    /* 固定した色に出す「金額」と「商品ページへのリンク」。
       ⚠️ App Proxy は金額もURLも返さない。あの口は商品ページを開くたびに
          叩かれるので Shopify を見に行かない作りになっていて、picking の
          products テーブルにも price と handle が無い。
          レシピ記事は記事側（Liquid）が商品そのものを持っているので、
          そこから variant_id → {u: URL, p: 金額} を渡してもらう。
       ⚠️ 渡されなかったもの（base coat など）は名前だけ。壊さない。 */
    var preInfo = {};
    try { preInfo = JSON.parse(root.getAttribute("data-preselect-info") || "{}"); }
    catch (e) { preInfo = {}; }

    /* この枠に入れる色を preQueue から1つ取り出す（取ったぶんは消す）。
       ⚠️ 同じ色を2つの枠に入れない。
       ⚠️ 在庫切れの色は入れない。選べないものが選ばれた状態になるとおかしい。 */
    function takePre(slot) {
      for (var qi = 0; qi < preQueue.length; qi++) {
        for (var pi = 0; pi < slot.options.length; pi++) {
          if (String(slot.options[pi].variant_id) === String(preQueue[qi])
              && Number(slot.options[pi].stock) > 0) {
            preQueue.splice(qi, 1);
            return slot.options[pi];
          }
        }
      }
      return null;
    }

    var slotsEl = root.querySelector("[data-slots]");
    var addBtn = root.querySelector("[data-add]");
    var noteEl = root.querySelector("[data-note]");
    var chosen = new Array(bundle.slots.length).fill(null);

    /* 枠の数で並べ方を決める（2026-10-23 翠さん）。
         3枠（basic）= 横に3つ
         4枠（first）= 2×2
         それ以外     = 入るだけ並べて折り返す
       ⚠️ 画面幅では決めない。同じ3枠でもスマホとPCで並びが変わると、
          パンフレットや店頭の見せ方と食い違う。 */
    /* ⚠️ 固定モードは枠の数にかかわらず横1列（2026-10-25 翠さん
          「PCの方もモバイルの方も横並びに4色または3色並べるように」）。
          選ばせないので、2×2にして1枠を大きく見せる理由が無い。 */
    /* まだ単品で売っていない色（予約販売中・coming soon）の扱い。
       ⚠️ 商品ページ … 選択肢から外す。在庫が無いのに「すぐ出荷」の約束に
            なってしまう。発売日時は preorder アプリのルールから来るので、
            発売の瞬間に勝手に選べるようになる（手で足す運用が消える）。
       ⚠️ レシピ記事（固定モード）… 外さない。色の一覧はこのブロックに
            寄せたので、外すと記事から色が消える。カードは出したまま、
            下でカートに追加ボタンを止める。 */
    if (!locked) {
      for (var si = 0; si < bundle.slots.length; si++) {
        var sl = bundle.slots[si];
        sl.options = (sl.options || []).filter(function (o) { return o.on_sale !== false; });
      }
    }

    var n = bundle.slots.length;
    slotsEl.className = "ecnue-bundle__slots " +
      (locked ? "is-lock" : n === 3 ? "is-3" : n === 4 ? "is-4" : "is-auto");

    bundle.slots.forEach(function (slot, index) {
      // 固定モードで、この枠に入れる色が決まっているなら選ばせない
      var preFixed = locked ? takePre(slot) : null;

      var card = document.createElement("div");
      card.className = "ecnue-bundle__card";

      var figure = document.createElement("div");
      figure.className = "ecnue-bundle__fig";
      var img = document.createElement("img");
      img.className = "ecnue-bundle__fig-img";
      img.alt = "";
      img.loading = "lazy";
      img.hidden = true;
      var ph = document.createElement("span");
      ph.className = "ecnue-bundle__fig-ph";
      // ⚠️ 選ぶ前にどれかの色を出すのはやめた（2026-10-23 翠さん）。
      //    もう選ばれていると誤解される。薄い面に枠の名前だけ置く。
      ph.textContent = slot.options.length === 1 ? "" : slot.label;
      figure.appendChild(img);
      figure.appendChild(ph);
      card.appendChild(figure);

      // ⚠️ ラベルとプルダウンは1つの箱に入れる。
      //    スマホでは写真の【横】に回すため、まとめて動かせる必要がある。
      var body = document.createElement("div");
      body.className = "ecnue-bundle__body";
      card.appendChild(body);

      /* ⚠️ 選べない枠では枠の名前を出さない。商品名と二重になる
            （2026-10-23 翠さん「base coat / top coat という表記はいらない」）。 */
      var label = document.createElement("span");
      label.className = "ecnue-bundle__card-label";
      label.textContent = slot.label;
      if (slot.options.length > 1 && !preFixed) body.appendChild(label);

      // 選択肢が1つの枠は固定の構成品。選ばせずに決める
      /* ＋ は card の【中】に入れて、右側に重ねて出す。
         ⚠️ card と並べて置くと、2列に折り返したとき次の行の頭に来て、
            何と何が足されるのか読めなくなる（2026-10-23 実測）。
            中に入れて absolute で出せば、必ずその card の右に付く。 */
      /* ＋ の置き方。
         ⚠️ 2列（4枠）のとき、2つ目の右に付けると行の終わりに取り残される。
            そこは行と行のあいだに1つ置く（2026-10-23 翠さんの赤入れ）。
         ⚠️ card の中に入れて absolute で右に出す。card と並べて置くと
            折り返したとき次の行の頭に落ちる。 */
      function addPlus() {
        var last = bundle.slots.length - 1;
        if (index >= last) return;
        var twoCols = bundle.slots.length === 4 && !locked;
        if (twoCols && index % 2 === 1) {
          // 行の終わり。ここには付けず、行間の ＋ を1つ置く
          var row = document.createElement("span");
          row.className = "ecnue-bundle__rowplus";
          row.setAttribute("aria-hidden", "true");
          row.textContent = "＋";
          slotsEl.appendChild(row);
          return;
        }
        var sep = document.createElement("span");
        sep.className = "ecnue-bundle__plus";
        sep.setAttribute("aria-hidden", "true");
        sep.textContent = "＋";
        card.appendChild(sep);
      }

      if (slot.options.length === 1 || preFixed) {
        var fixedOpt = preFixed || slot.options[0];
        chosen[index] = fixedOpt;
        show(fixedOpt);
        var info = preInfo[String(fixedOpt.variant_id)];

        // ⚠️ 必ず入るものは選ばせない。枠線を出すと選べそうに見えるので、名前だけ。
        var fixed = document.createElement("span");
        fixed.className = "ecnue-bundle__fixed";
        fixed.textContent = fixedOpt.title;
        body.appendChild(fixed);

        /* 金額と、その商品のページへのリンク（2026-10-25 翠さん
           「各色の下に金額を入れて、タップすると商品ページにも飛べるように」）。
           ⚠️ 使用アイテムの一覧をこのブロックに寄せたので、ここが唯一の
              商品への入口になる。リンクを落とすと色を見に行けなくなる。 */
        if (info && info.p) {
          var price = document.createElement("span");
          price.className = "ecnue-bundle__fixed-price";
          price.textContent = info.p;
          body.appendChild(price);
        }
        if (info && info.u) {
          var link = document.createElement("a");
          link.className = "ecnue-bundle__fixed-link";
          link.href = info.u;
          link.setAttribute("aria-label", fixedOpt.title);
          card.appendChild(link);
        }

        slotsEl.appendChild(card);
        addPlus();
        return;
      }

      /* 選ぶところ。押すと色玉のグリッドが開く。
         ⚠️ ネイティブの <select> も、小さな色玉を並べたリストもやめた。
            15px まで縮めると球体の質感が潰れて、ただの点になる
            （2026-10-23 翠さん「色玉がスクリーンショットと違う」）。
            カラー比較ページの「カラーを選択」と同じ、大きな色玉を並べて選ばせる。
         ⚠️ 色玉は custom.mood_veil_slide_show（カラーチップ）。商品写真ではない。 */
      var sel = document.createElement("div");
      sel.className = "ecnue-bundle__sel";

      var selBtn = document.createElement("button");
      selBtn.type = "button";
      selBtn.className = "ecnue-bundle__sel-btn";
      selBtn.setAttribute("aria-haspopup", "dialog");
      selBtn.setAttribute("aria-label", slot.label);
      var selDot = document.createElement("span");
      selDot.className = "ecnue-bundle__dot";
      selDot.hidden = true;
      var selName = document.createElement("span");
      selName.className = "ecnue-bundle__sel-name";
      selName.textContent = "select";
      selBtn.appendChild(selDot);
      selBtn.appendChild(selName);
      sel.appendChild(selBtn);

      /* ⚠️ 色玉で選ばせるのは「色が付いているもの」だけ（2026-10-23 翠さん）。
            base coat / dazzlin top coat は透明で、色玉にしても見分けがつかない。
            こういう枠は素直なリストで選ばせる。判定は色玉を持っているかどうか。 */
      var hasSwatch = slot.options.some(function (o) { return !!o.swatch_url; });

      var inlineList = null;
      if (false) {
        inlineList = document.createElement("ul");
        inlineList.className = "ecnue-bundle__list";
        inlineList.setAttribute("role", "listbox");
        inlineList.hidden = true;
        slot.options.forEach(function (opt) {
          var li = document.createElement("li");
          li.className = "ecnue-bundle__list-item";
          li.setAttribute("role", "option");
          li.textContent = opt.title;
          if (Number(opt.stock) <= 0) {
            li.className += " is-oos";
            li.setAttribute("aria-disabled", "true");
          } else {
            li.addEventListener("click", function (e) {
              e.stopPropagation();
              chosen[index] = opt;
              selName.textContent = opt.title;
              selDot.hidden = true;
              var all = inlineList.querySelectorAll(".ecnue-bundle__list-item");
              for (var k = 0; k < all.length; k++) all[k].setAttribute("aria-selected", "false");
              li.setAttribute("aria-selected", "true");
              inlineList.hidden = true;
              show(opt);
              refresh();
            });
          }
          inlineList.appendChild(li);
        });
        sel.appendChild(inlineList);
        document.addEventListener("click", function () { inlineList.hidden = true; });
      }

      selBtn.addEventListener("click", function () {
        openGrid(slot, index, selDot, selName, show, hasSwatch);
      });

      if (preQueue.length) {
        var pre = takePre(slot);
        if (pre) {
          chosen[index] = pre;
          selName.textContent = pre.title;
          if (pre.swatch_url) {
            selDot.style.backgroundImage = "url(" + pre.swatch_url + ")";
            selDot.hidden = false;
          } else {
            selDot.hidden = true;
          }
          show(pre);
        }
      }

      body.appendChild(sel);
      slotsEl.appendChild(card);
      addPlus();

      /* ⚠️ 枠の大きい写真は【商品画像】。色玉ではない（2026-10-23 翠さん）。
            色玉は選ぶときに見分けるためのもので、商品の顔ではない。 */
      /* 枠の大きい写真を差し替える。
         ⚠️ ここは写真だけを触る。セレクターの中の色玉は選んだ側で面倒を見る。
            以前ここから色玉を触っていて、色玉を外したあとも参照が残り、
            例外でモーダルが閉じなくなった（2026-10-23）。
         ⚠️ 大きい写真は【商品画像】。色玉ではない（翠さん）。 */
      function show(opt) {
        var src = opt && opt.image;
        if (src) {
          img.src = src;
          img.hidden = false;
          ph.hidden = true;
        } else {
          img.hidden = true;
          ph.hidden = false;
        }
      }
    });

    /* 色玉のグリッド。枠ごとに作らず1枚を使い回す。
       ⚠️ body 直下に置く。商品エリアの親に transform があると position:fixed が
          効かず、画面の真ん中に出ない（テーマで何度も踏んでいる）。 */
    var modal = null;
    function buildModal() {
      if (modal) return modal;
      modal = document.createElement("div");
      modal.className = "ecnue-bundle__modal";
      modal.hidden = true;
      modal.innerHTML =
        '<div class="ecnue-bundle__modal-bg" data-close></div>' +
        '<div class="ecnue-bundle__modal-panel" role="dialog" aria-modal="true">' +
          '<div class="ecnue-bundle__modal-head">' +
            '<span class="ecnue-bundle__modal-title"></span>' +
            '<button type="button" class="ecnue-bundle__modal-x" data-close aria-label="close">&times;</button>' +
          '</div>' +
          '<input type="search" class="ecnue-bundle__modal-search" placeholder="search by name" autocomplete="off">' +
          '<p class="ecnue-bundle__modal-current"></p>' +
          '<div class="ecnue-bundle__modal-grid"></div>' +
        '</div>';
      document.body.appendChild(modal);
      modal.addEventListener("click", function (e) {
        if (e.target.hasAttribute("data-close")) closeGrid();
      });
      document.addEventListener("keydown", function (e) {
        if (e.key === "Escape" && !modal.hidden) closeGrid();
      });
      return modal;
    }
    function closeGrid() {
      if (!modal) return;
      modal.hidden = true;
      document.documentElement.style.overflow = "";
    }
    /* 選ぶ画面。2通りある。
       ⚠️ 色が付いているもの（カラー）は色玉を並べる。
       ⚠️ 色で選べないもの（base coat / dazzlin top coat）は、写真を左に置いて
          右に名前と説明を書いたカードを縦に並べる（2026-10-23 翠さん）。
          透明なものを色玉にしても見分けがつかない。 */
    function openGrid(slot, index, dotEl, nameEl, showFn, asSwatch) {
      var m = buildModal();
      m.querySelector(".ecnue-bundle__modal-title").textContent = slot.label;
      var cur = m.querySelector(".ecnue-bundle__modal-current");
      var grid = m.querySelector(".ecnue-bundle__modal-grid");
      var search = m.querySelector(".ecnue-bundle__modal-search");
      search.value = "";
      grid.textContent = "";
      grid.className = "ecnue-bundle__modal-grid " + (asSwatch ? "is-swatch" : "is-cards");
      // 選択肢が少ない枠では検索欄は邪魔なだけ
      search.hidden = slot.options.length < 8;
      cur.hidden = !asSwatch;
      cur.textContent = chosen[index] ? chosen[index].title : "";

      if (!asSwatch) {
        slot.options.forEach(function (opt) {
          var b = document.createElement("button");
          b.type = "button";
          b.className = "ecnue-bundle__card-opt";
          if (chosen[index] && chosen[index].variant_id === opt.variant_id) b.className += " is-on";
          var ph2 = document.createElement("span");
          ph2.className = "ecnue-bundle__card-opt-img";
          if (opt.image) ph2.style.backgroundImage = "url(" + opt.image + ")";
          b.appendChild(ph2);
          var tx = document.createElement("span");
          tx.className = "ecnue-bundle__card-opt-tx";
          var h = document.createElement("span");
          h.className = "ecnue-bundle__card-opt-name";
          h.textContent = opt.title;
          tx.appendChild(h);
          if (opt.subtitle) {
            var sub = document.createElement("span");
            sub.className = "ecnue-bundle__card-opt-sub";
            sub.textContent = opt.subtitle;
            tx.appendChild(sub);
          }
          if (opt.description) {
            /* ⚠️ 文ごとに入っている改行は、そのまま出すと折り返しと混ざって
                  どこで切れているのか読めなくなる（2026-10-23 翠さん）。
                  空行＝段落の区切りだけを残し、文の途中の改行は詰めて
                  折り返しに任せる。日本語なので間に空白は入れない。 */
            var de = document.createElement("span");
            de.className = "ecnue-bundle__card-opt-desc";
            String(opt.description).split(/\n\s*\n/).forEach(function (para) {
              var t = para.replace(/\n/g, "").trim();
              if (!t) return;
              var pEl = document.createElement("span");
              pEl.className = "ecnue-bundle__card-opt-para";
              pEl.textContent = t;
              de.appendChild(pEl);
            });
            tx.appendChild(de);
          }
          b.appendChild(tx);
          if (Number(opt.stock) <= 0) {
            b.className += " is-oos";
            b.disabled = true;
          } else {
            b.addEventListener("click", function () {
              chosen[index] = opt;
              nameEl.textContent = opt.title;
              dotEl.hidden = true;        // 色玉を持たないものは丸を出さない
              showFn(opt);
              refresh();
              closeGrid();
            });
          }
          grid.appendChild(b);
        });
        m.hidden = false;
        document.documentElement.style.overflow = "hidden";
        return;
      }

      slot.options.forEach(function (opt) {
        var b = document.createElement("button");
        b.type = "button";
        b.className = "ecnue-bundle__chip";
        b.setAttribute("data-name", String(opt.title || "").toLowerCase());
        if (chosen[index] && chosen[index].variant_id === opt.variant_id) {
          b.className += " is-on";
        }
        var src = opt.swatch_url;
        if (src) {
          var im = document.createElement("span");
          im.className = "ecnue-bundle__chip-img";
          im.style.backgroundImage = "url(" + src + ")";
          b.appendChild(im);
        } else {
          // 色玉が無いもの（base/top など）は名前だけ。空の丸は出さない
          b.className += " is-plain";
        }
        var nm = document.createElement("span");
        nm.className = "ecnue-bundle__chip-name";
        nm.textContent = opt.title;
        b.appendChild(nm);
        if (Number(opt.stock) <= 0) {
          b.className += " is-oos";
          b.disabled = true;
        } else {
          b.addEventListener("click", function () {
            chosen[index] = opt;
            nameEl.textContent = opt.title;
            // 色玉が無いもの（base/top など透明なもの）は丸を出さない
            if (opt.swatch_url) {
              dotEl.style.backgroundImage = "url(" + opt.swatch_url + ")";
              dotEl.hidden = false;
            } else {
              dotEl.hidden = true;
            }
            showFn(opt);
            refresh();
            closeGrid();
          });
          // 名前も出しておく。押す前にどれを触っているか分かるように
          b.addEventListener("mouseenter", function () { cur.textContent = opt.title; });
        }
        grid.appendChild(b);
      });

      search.oninput = function () {
        var q = search.value.trim().toLowerCase();
        var chips = grid.querySelectorAll(".ecnue-bundle__chip");
        for (var i = 0; i < chips.length; i++) {
          chips[i].hidden = q ? chips[i].getAttribute("data-name").indexOf(q) < 0 : false;
        }
      };

      m.hidden = false;
      document.documentElement.style.overflow = "hidden";
    }

    function remaining() {
      return chosen.filter(function (c) { return !c; }).length;
    }

    /* ⚠️ テーマのボタンの見た目をそのまま借りる（2026-10-23 翠さん）。
          自前で色や角丸を決めると、店の世界観から浮く。
          テーマを変えても勝手に追従してほしいので、クラス名だけ借りる。 */
    var themeBtnClass = (function () {
      var f = document.querySelector("form[action*='/cart/add'] [type=submit]");
      return f && f.className ? f.className : "";
    })();
    if (themeBtnClass) addBtn.className = "ecnue-bundle__add " + themeBtnClass;

    function refresh() {
      // ⚠️ 「あと N つ」は出さない（2026-10-23 翠さん）。
      //    押せないボタンを見れば足りていないことは分かる。
      //    この枠はカートに追加できなかったときのお知らせにだけ使う。
      addBtn.disabled = remaining() > 0;
      noteEl.hidden = true;
    }

    addBtn.addEventListener("click", function () {
      if (remaining() > 0) return;
      addBtn.disabled = true;
      var original = addBtn.textContent;
      addBtn.textContent = "追加しています…";

      /* _ 始まりのプロパティはお客様に見えないが、Shopifyの注文画面には出る。
         ⚠️ ここは増やさない。注文画面が読めなくなる（2026-10-23 翠さん）。
            picking が要るのは variant_id だけ。セットのIDは使っていないし、
            名前は下の「color 1: her」などで足りる。 */
      var properties = {
        _ecnue_selection: chosen.map(function (c) { return c.variant_id; }).join(",")
      };
      /* どのレシピから買われたか。
         ⚠️ 増やすなと言われているプロパティをあえて1つ足している（2026-10-25 翠さん
            「カートの画像をレシピの表紙にしたい」）。入れるのは短いハンドル1つだけで、
            画像のURLは入れない。URLを持たせると注文画面が長くなって読めなくなる。
            カート側は articles[このハンドル] から表紙を引く。
         ⚠️ 注文画面には _recipe: misty-sparkle-nails と1行出る。
            どのレシピ経由の注文か分かるので、ここは邪魔にならない。 */
      var recipe = root.getAttribute("data-cart-recipe");
      if (recipe) properties._recipe = recipe;
      /* 固定の構成品（選択肢が1つの枠）は1行にまとめて出す。
         ⚠️ 以前は出していなかったが、first ecnue set のカートが
            色2つしか並ばず「ベースとトップが入っていない」と見えた
            （2026-10-23 翠さん）。入ってはいたが、伝わらなければ同じこと。
         ⚠️ 枠ごとに出すと「base coat: base coat」と同じ言葉が2回出るので、
            枠の名前は使わずに品名だけを並べる。 */
      var fixed = [];
      bundle.slots.forEach(function (slot, index) {
        if (slot.options.length === 1 && chosen[index]) fixed.push(chosen[index].title);
      });
      if (fixed.length) properties["セット内容"] = fixed.join(" ／ ");

      bundle.slots.forEach(function (slot, index) {
        if (slot.options.length > 1) properties[slot.label] = chosen[index].title;
      });

      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          items: [{ id: Number(variantId), quantity: 1, properties: properties }]
        })
      })
        .then(function (r) {
          if (!r.ok) throw new Error("add failed");
          window.location.href = "/cart";
        })
        .catch(function () {
          addBtn.disabled = false;
          addBtn.textContent = original;
          noteEl.hidden = false;
          noteEl.textContent = "カートに追加できませんでした。もう一度お試しください。";
        });
    });

    refresh();

    /* 固定モードで、まだ単品で売っていない色が入っているとき。
       色は並べたまま、カートに追加と金額だけ消す
       （2026-10-25 翠さん「単品販売が開始するまで出さなくていい」）。 */
    if (locked) {
      var waiting = chosen.filter(function (c) { return c && c.on_sale === false; });
      if (waiting.length) {
        root.setAttribute("data-noadd", "1");
        var priceEl = root.querySelector(".ecnue-recipebundle__price");
        if (priceEl) priceEl.hidden = true;
        var at = waiting
          .map(function (c) { return c.sale_starts_at; })
          .filter(Boolean)
          .sort()
          .pop();
        if (at) {
          noteEl.textContent = whenText(at);
          noteEl.hidden = false;
        }
      }
    }

    root.hidden = false;

    // 自社の選択UIを出したら、テーマ標準のカートボタンは隠す
    // （選択内容の無いまま親だけがカートに入るのを防ぐ）
    hideThemeButtons(root);
  }
})();
